import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Showcase from "@/components/sections/Showcase";
import WhyUs from "@/components/sections/WhyUs";
import CtaBand from "@/components/sections/CtaBand";
import Footer from "@/components/Footer";

const Landing = () => (
  <main data-testid="landing-page">
    <Hero />
    <Services />
    <Showcase />
    <WhyUs />
    <CtaBand />
    <Footer />
  </main>
);

export default Landing;
